import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '10px 40px 24px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    fontSize: '16px',
    color: '#545455',
    marginTop: '10px'
  },
  cardWrapper: {
    margin: '15px 40px',
    padding: '20px',
    minHeight: '150px',
    maxHeight: '500px',
    borderRadius: '2px',
    display: 'flex',
    flexWrap: 'wrap',
    boxShadow: '0px 0px 6px #00000029',
  },
  cardContent: {
    maxHeight: '500px',
    overflowY: 'scroll'
  },
  cardTitle: {
    color: '#5F6062',
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '10px'
  },
  cardDescription: {
    fontSize: '13px',
    color: '#5F6062',
    lineHeight: 1.8
  },
  subCard: {
    backgroundColor: '#F6F6F6',
    width: '100%',
    margin: '20px 0'
  },
  subCardTitle: {
    fontSize: '16px',
    color: '#F37320',
    fontWeight: 'bold'
  },
  subCardContent: {
    padding: '16px 20px',
    fontSize: '13px',
    color: '#5F6062',
    lineHeight: 1.8
  },
  subHeading: {
    padding: '12px 20px 0',
    color: '#F37320',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  scrollSpyContainer: {
    borderLeft: '2px solid #F37320',
    paddingLeft: '10px'
  },
  scrollSpyListText: {
    fontSize: '13px',
    color: '#545455',
    textDecoration: 'none',
    paddingLeft: '5px'
  },
  currentSection: {
    backgroundColor: '#FFF6F1',
  }
}))

export { useStyles }